export default {
  roles: `/v1/roles/roles`
};
